import { inject, injectable } from "inversify";
import { action, makeObservable } from "mobx";
import CompositeDataService from "@/src/application/services/composite-data-service";
import { CompositeDataV2ControllerApi } from "@generated/n3-backend-api/n3-backend-open-api-gen/composite-data-v2-controller-api";

@injectable()
export default class CompositeDataServiceImpl extends CompositeDataService {
  constructor(
    @inject(CompositeDataV2ControllerApi)
    private readonly compositeDataApi: CompositeDataV2ControllerApi
  ) {
    super();
    makeObservable(this, {
      fetchDeviceWithMeasurements: action.bound,
    });
  }

  public async fetchDeviceWithMeasurements(deviceId: number) {
    const response = await this.compositeDataApi.getDeviceWithMeasurements(deviceId);
    return response.data;
  }
}
